module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "weui-tab"
  }, [_c('div', {
    staticClass: "weui-tab__panel"
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.showTabbar) ? _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "selected": _vm.$route.name === 'homeworks',
      "link": "/homeworks"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/tick.svg")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/tick_active.svg"),
      "width": "27px"
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("今天作业")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.$route.name === 'schedule',
      "link": "/schedule"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/schedule.svg")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/schedule_active.svg")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("课程表")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.$route.name === 'courses',
      "link": "/courses"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/statistic.svg")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/statistic_active.svg")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("课程概况")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.$route.name === 'settings',
      "link": "/settings"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/settings.svg")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/settings_active.svg")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    slot: "label"
  }, [_vm._v("更多设定")])])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 572
// module chunks = 1